import { Component } from '@angular/core';
import { UtilsService } from './services/utils.service';
import { TranslateService } from '@ngx-translate/core'
import * as moment from 'moment'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'frontend';

  constructor (private readonly utils: UtilsService,
    private readonly translate: TranslateService) {
    this.initMomentLocale()
    this.initLang()
  }

  private initMomentLocale () {
    moment().locale('es')
  }

  private initLang () {
    // this language will be used as a fallback when a translation isn't found in the current language
    this.translate.setDefaultLang('en')

    this.translate.addLangs(['en', 'es', 'fr', 'ca'])

    // the lang to use, if the lang isn't available, it will use the current loader to get them
    this.translate.use('es')
  }
}
